import React from 'react';
import DataGrid from './common/dataGrid';
import moment from 'moment';
import '../public/less/defaultValues.less';
import ReactModal from 'react-modal';
import { Form, FormGroup, Col, ControlLabel, Button, FormControl } from 'react-bootstrap';
import axios from 'axios';
var Confirm = require('react-confirm-bootstrap');

module.exports = class indexForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className='titleImage'><div className='container'><h2>Measurements Values</h2></div></div>
                <div className='container'>
                    <div className='top-pad'>
                        <MeasurementParameter title="Humidity" ajaxUrl="/data/getHumidityDefaults" updateUrl="/data/saveHumidityDefaults"
                            deleteUrl="/data/deleteHumidityDefaults"
                            gridID="humidityGrid" avgObj={humidityAvgFormat}
                            gridChildren={[{ key: 'Forhead', value: 'Forehead' },
                            { key: 'RightCheek', value: 'RightCheek' },
                            { key: 'LeftCheek', value: 'LeftCheek' },
                            { key: 'Chine', value: 'Chin' }]}
                            modalChildren={[{ key: 'Forhead', caption: 'Forehead' },
                            { key: 'RightCheek', caption: 'Right cheek' },
                            { key: 'LeftCheek', caption: 'Left cheek' },
                            { key: 'Chine', caption: 'Chin' }]} />
                        <hr />
                        {/* <MeasurementParameter title="Sebum" ajaxUrl="/data/getSebumDefaults" updateUrl="/data/saveSebumDefaults" gridID="sebumGrid" avgObj={sebumAvgFormat}
                            deleteUrl="/data/deleteSebumDefaults" gridChildren={[{ key: 'Forhead', value: 'Forehead' },
                            { key: 'RightCheek', value: 'RightCheek' }]}
                            modalChildren={[{ key: 'Forhead', caption: 'Forehead' },
                            { key: 'RightCheek', caption: 'Right cheek' }]} />
                        <hr /> */}
                        <MeasurementParameter title="Elasticity" ajaxUrl="/data/getElasticityDefaults" deleteUrl="/data/deleteElasticityDefaults" updateUrl="/data/saveElasticityDefaults" gridID="elasticityGrid"
                            gridChildren={[{ key: 'Temple', value: 'Temple' }]}
                            modalChildren={[{ key: 'Temple', caption: 'Temple' }]} />
                    </div>
                </div>
            </div>
        )
    }
};

class MeasurementTablePreview extends React.Component {
    render() {
        var tableHeader = [];
        var tableContent = [];
        for (var prop in this.props.data) {
            if (prop != "IsActive" && prop != "ID" && prop != "EndTimeStamp" && prop != "TimeStamp") {
                tableHeader.push(<td key={prop}>{prop}</td>);
                tableContent.push(<td key={prop}>{this.props.data[prop]}</td>);
            }
        }
        return (
            <div>
                Are you sure you want to delete this?
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            {tableHeader}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {tableContent}
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

class MeasurementParameter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            data: {},
            rowID: -1
        }

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.EditDelete = this.EditDelete.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    EditDelete(cell, row, enumObject, index) {
        var confirmText = "Confirm Delete " + this.props.title;
        var body = <MeasurementTablePreview data={row} />;
        return (
            <div>
                <div className='editUrl button' onClick={() => { this.handleOpenModal(row, index) }}> Edit</div> |
                <Confirm
                    onConfirm={() => { this.handleDelete(row, index) }}
                    body={body}
                    confirmText={confirmText}
                    title={confirmText}>
                    <div className='deleteUrl button'>Delete</div>
                </Confirm>
            </div>)
    }

    handleOpenModal(data, rowID) {
        if (data == null) {
            data = { AgeRangeMin: 0, AgeRangeMax: 0 };
            for (var i = 0; i < this.props.gridChildren.length; i++) {
                data[this.props.gridChildren[i].key] = 0;
            }
        }

        this.setState({
            data: clone(data),
            rowID: rowID,
            showModal: true
        });
    }

    handleCloseModal() {
        this.setState({ showModal: false, rowID: -1 });
    }

    onChange(evt) {
        var data = this.state.data;

        var value = evt.target.value;
        var id = evt.target.id;

        data[id] = parseInt(value);

        this.setState({ data: data });
    }

    handleSave(evt) {
        evt.preventDefault();
        var data = this.state.data;
        data["TimeStamp"] = new Date();

        var _this = this;
        axios
            .post(this.props.updateUrl, { data })
            .then(function (data) {
                var fullData = _this._grid.getData();
                if (_this.state.rowID == -1) {
                    fullData.push(data.data);
                }
                else {
                    fullData[_this.state.rowID] = data.data;
                }

                _this._grid.setData(fullData);
                _this.handleCloseModal();
            })
            .catch(function (error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            });
    }

    handleDelete(row, index) {
        axios
            .post(this.props.deleteUrl, { ID: row.ID })
            .then(function (data) {
                console.log(data);
            })
            .catch(function (error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            });
        this._grid.getData().splice(index, 1);
        this._grid.setData(this._grid.getData());
    }

    render() {
        var rowData = this.state.data;

        var gridChildren = this.props.gridChildren.map(function (element) {
            return (
                <TableHeaderColumn dataField={element.key} key={element.key} dataSort>{element.value}</TableHeaderColumn>
            )
        });

        var _this = this;
        var modalChildren = this.props.modalChildren.map(function (element) {
            var value = rowData[element.key];

            return (
                <FormRow id={element.key} key={element.key} type="text" caption={element.caption} value={value} onChange={_this.onChange} />
            )
        });

        var avgObj;
        if (this.props.avgObj) {
            avgObj = <TableHeaderColumn dataField='' dataFormat={this.props.avgObj} dataSort>Avg.</TableHeaderColumn>;
        }
        else {
            avgObj = <TableHeaderColumn dataField='' hidden dataSort>Avg.</TableHeaderColumn>;
        }

        return (
            <div>
                <div className='col-md-8'>
                    <h3>{this.props.title}</h3>
                </div>
                <div className='float-right'>
                    <button className='purple btn btn-default btn btn-default' style={{ width: '130px', height: '35px', display: 'inline-block' }} onClick={() => { this.handleOpenModal(null, -1) }}>+ ADD NEW LINE</button>
                </div>

                <DataGrid
                    ajaxUrl={this.props.ajaxUrl}
                    ID={this.props.gridID} ref={(grid) => { this._grid = grid; }}>
                    <TableHeaderColumn isKey hidden dataField='ID' />
                    <TableHeaderColumn
                        dataField='TimeStamp'
                        dataFormat={dateFormatter}
                        dataSort>Time stamp</TableHeaderColumn>
                    {gridChildren}
                    {avgObj}
                    <TableHeaderColumn dataField='AgeRangeMin'>Min. Age Range</TableHeaderColumn>
                    <TableHeaderColumn dataField='AgeRangeMax'>Max. Age Range</TableHeaderColumn>
                    <TableHeaderColumn dataField='' dataFormat={this.EditDelete}></TableHeaderColumn>
                </DataGrid>

                <ReactModal
                    isOpen={this.state.showModal}
                    contentLabel="onRequestClose Example"
                    onRequestClose={this.handleCloseModal}
                    className="Modal-Popup"
                    overlayClassName="Modal-Overlay">

                    <h3>{this.props.title}</h3>
                    <Form horizontal>
                        <FormRow id="AgeRangeMin" type="text" caption="Min. age range" value={rowData.AgeRangeMin} onChange={this.onChange} />
                        <FormRow id="AgeRangeMax" type="text" caption="Max. age range" value={rowData.AgeRangeMax} onChange={this.onChange} />
                        {modalChildren}
                        <button className="btnSave" onClick={this.handleSave}>Save</button> <button className="btnCancel" onClick={this.handleCloseModal}>Cancel</button>
                    </Form>
                </ReactModal>
            </div>
        )
    }
}


class FormRow extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <FormGroup>
                <Col componentClass={ControlLabel} sm={6}>
                    {this.props.caption}
                </Col>
                <Col sm={6}>
                    <FormControl type="text" id={this.props.id} name={this.props.id} value={this.props.value} onChange={this.props.onChange} />
                </Col>
            </FormGroup>
        )
    }
}

function clone(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
}


function dateFormatter(cell, row) {
    return `${moment(new Date(cell)).format("DD.MM.YYYY")}`;
}

function humidityAvgFormat(cell, row) {
    var avg = (row.Chine + row.Forhead + row.RightCheek + row.LeftCheek) / 4;
    return <div className='boldCell'>{avg}</div>;
}

function sebumAvgFormat(cell, row) {
    var avg = (row.Forhead + row.RightCheek) / 2;
    return <div className='boldCell'>{avg}</div>;
}




// WEBPACK FOOTER //
// ./modules/defaultValues.jsx